import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { textColorStatus } from 'src/utils/Helper';
import { Box, capitalize } from '@mui/material';
import PricelogStatusStepper from './PricelogStatusStepper';

export default React.memo(function PopoverWithStatus({ value, row }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = event => {
    if (row.priceChangeType === 'downprice') {
      setAnchorEl(event.currentTarget);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <Typography
        variant='caption'
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup='true'
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        color={textColorStatus(value)}
      >
        {value && capitalize(value)} {row.isDeleted ? '(Deleted)' : ''}
      </Typography>
      <Popover
        id='mouse-over-popover'
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box
          sx={{
            py: 1,
          }}
        >
          <PricelogStatusStepper key={row.primaryisbn} row={row} />
        </Box>
      </Popover>
    </div>
  );
});
